function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.207 23.751l12.471-10.984a1.066 1.066 0 0 0 0-1.539L7.207.249a.987.987 0 0 0-1.414.107l-1.557 1.85a1.028 1.028 0 0 0 .111 1.438l9.453 8.165a.25.25 0 0 1 0 .379l-9.45 8.168a1.021 1.021 0 0 0-.349.7 1 1 0 0 0 .238.741l1.558 1.851a.989.989 0 0 0 1.414.107z"
});

var SvgArrowButtonRightBold = function SvgArrowButtonRightBold(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgArrowButtonRightBold;